import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";       // ✅ Correct path!
import About from "./pages/About";
import Tours from "./pages/Tours";
import Contact from "./pages/Contact";
import SpitiTour from "./pages/SpitiTour";
import ManaliTour from "./pages/ManaliTour";
import ShimlaChandigarhTour from "./pages/ShimlaChandigarhTour";
import ToursPackages from "./pages/TourPackages";
import HimachalTour from "./pages/HimachalTour";
import Reviews from "./pages/Reviews";
import PangiValleyTour from "./pages/PangiValleyTour";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";
import Notifications from "./components/Notifications"; // <-- Import Notifications component
import ViewReviews from "./components/ViewReviews"; // <-- Import ViewReviews component
import 'bootstrap-icons/font/bootstrap-icons.css';
import Gallery from "./components/Gallery";
import AdminGallery from "./components/AdminGallery";
function App() {
  return (
    <Router>
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/tours-packages" element={<ToursPackages />} />
        <Route path="/tours" element={<Tours />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/spiti-tour" element={<SpitiTour />} />
        <Route path="/manali-tour" element={<ManaliTour />} />
        <Route path="/shimla-chandigarh-tour" element={<ShimlaChandigarhTour />} />
        <Route path="/Himachal-tour" element={<HimachalTour />} />
        <Route path="/pangi-valley-tour" element={<PangiValleyTour />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/notifications" element={<Notifications />} /> {/* Add this route for notifications */}
        <Route path="/view-reviews" element={<ViewReviews />} /> {/* Add this route for reviews */}
        <Route path="/gallery" element={<Gallery/>}/>
        <Route path="/admin-gallery" element={<AdminGallery/>}/>
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
